import { z } from 'zod';

export const updateAnamnesisSchema = z.object({
  patient_id: z.string().min(1),
  itemValues: z.array(
    z.object({
      item_id: z.string().min(1),
      value: z.string().nullable(),
    }),
  ),
});

export type UpdateAnamnesisPayload = z.infer<typeof updateAnamnesisSchema>;
